export default __webpack_public_path__ + "static/media/Measure.fe058fbef3e226e3eedf59b5aa3d9988.svg";